import React from 'react'
import { Form, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ArraySelect from '../Select/ArraySelect'
import getPreparedVariants from '../../utils/getPreparedVariants'
import styled from 'styled-components'

const StyleInputWrapper = styled.div`
  @media screen and (max-width: 486px) {
    margin-top: 20px;
  }
`
const VariantSelect = ({
  variants,
  selectedFirstPartVariant,
  handleChangeFirstPartVariant,
  selectedVariantError,
  selectedSecondPartVariant,
  handleChangeSecondPartVariant,
  defaultOptionIsSelectableFirstPart,
}) => {
  const preparedVariants = getPreparedVariants(variants)
  const preparedVariant = preparedVariants.find(
    (v) => v.displayName === selectedFirstPartVariant
  )
  const subVariants =
    selectedFirstPartVariant && preparedVariant
      ? preparedVariant.subVariants
      : []
  const { t } = useTranslation()
  return (
    <Row className='variant-select-row'>
      <Form.Group as={Col} style={{ width: '100%', padding: '0' }}>
        <ArraySelect
          onChange={handleChangeFirstPartVariant}
          isInvalid={selectedVariantError}
          value={selectedFirstPartVariant}
          options={preparedVariants}
          defaultOptionIsSelectable={defaultOptionIsSelectableFirstPart}
          returnEvent
        />
        <Form.Control.Feedback type='invalid'>
          {selectedVariantError && t('productDetail:selectVariantSize')}
        </Form.Control.Feedback>
      </Form.Group>

      {subVariants.length ? (
        <Form.Group as={Col} style={{ padding: '0' }}>
          <StyleInputWrapper>
            <ArraySelect
              onChange={handleChangeSecondPartVariant}
              isInvalid={selectedVariantError}
              value={selectedSecondPartVariant}
              options={subVariants}
              returnEvent
            />
          </StyleInputWrapper>
        </Form.Group>
      ) : (
        ''
      )}
    </Row>
  )
}

export default VariantSelect
